import { gameData } from "../../GameManager";
import { getActorWeight, getWeightLoad } from "../../items/formulas";
import { Actor } from "../Actor";

export const endOfTurnEffects = () => {
  gameData.actors.forEach((a) => {
    accumulateStagger(a);
    regenStats(a);
    expireStatuses(a);
    clearStates(a);
  });
};

export const accumulateStagger = (a: Actor) => {
  if (a.status.staggered) {
    a.status.staggeredCount = 1 + (a.status.staggeredCount || 0);
  }
};

export const regenStats = (a: Actor) => {
  if (!a.status.hit) {
    a.poise.change(Math.ceil(a.poise.max * 0.33333));
  }

  const staminaMultiplier =
    100 <= getWeightLoad(getActorWeight(a), a.attributes.weight) ? 0 : 1;
  if (100 <= getWeightLoad(getActorWeight(a), a.attributes.weight)) {
    a.stamina.change(-2);
  } else if (a.status.sprinted || a.status.staggered) {
    return;
  } else if (a.status.waited) {
    a.stamina.change(staminaMultiplier * 40);
  } else if (a.status.moved) {
    a.stamina.change(staminaMultiplier * 20);
  }
};

export const expireStatuses = (a: Actor) => {
  if (a.poise.current) {
    a.status.staggeredCount = 0;
    a.status.staggered = false;
  } else if (gameData.player === a && 3 <= (a.status.staggeredCount || 0)) {
    a.status.staggeredCount = 0;
    a.status.staggered = false;
    a.poise.fill();
  }
};

export const clearStates = (a: Actor) => {
  a.status.waited = false;
  a.status.hit = false;
  a.status.moved = false;
  a.status.blocking = false;
  a.status.replanned = false;
  a.status.sprinted = false;
};
